export default __webpack_public_path__ + "static/media/SFLogo.5c5bdfd6.png";